import { render, staticRenderFns } from "./ColorSchemePickerNew.vue?vue&type=template&id=0f55a8c2&"
import script from "./ColorSchemePickerNew.vue?vue&type=script&lang=ts&"
export * from "./ColorSchemePickerNew.vue?vue&type=script&lang=ts&"
import style0 from "./ColorSchemePickerNew.vue?vue&type=style&index=0&id=0f55a8c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports